module.exports = __webpack_public_path__ + "img/filipino.34b19568.svg";